import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import api from 'api';

function PanelPurchaseCookbook() {
    const data = useSelector(state => state);
    const user = data.user;

    const getInitialName = () => {
        const name = user.name;
        return name.indexOf('@') >= 0 ? '' : name;
    };

    const [orderData, setOrderData] = useState({
        name: getInitialName(),
        street: user.street,
        city: user.city,
        zip: user.zip,
        country: user.country,
        company_name: '',
        company_street: '',
        company_city: '',
        company_zip: '',
        company_country: '',
        email: user.email,
        phone: user.phone,
        ic: '',
        dic: '',
        comment: '',
        terms: false,
        currency: 'CZK',
    });
    const [orderSent, setOrderSent] = useState(false);
    const [inputCompanyData, setInputCompanyData] = useState(false);
    const [inputComment, setInputComment] = useState(false);

    const onChange = (e) => {
        const key = e.target.name;
        const value = key === 'terms' ? e.target.checked : e.target.value;
        setOrderData(prev => ({ ...prev, [key]: value }));
    };

    const switchCurrency = () => {
        setOrderData(prev => ({ ...prev, currency: prev.currency === 'CZK' ? 'EUR' : 'CZK' }));
    };

    const sendOrder = (e) => {
        e.preventDefault();
        if (orderData.name === '') { alert('Prosím vyplňte Vaše jméno.'); return; }
        if (orderData.street === '') { alert('Prosím vyplňte ulici.'); return; }
        if (orderData.city === '') { alert('Prosím vyplňte město.'); return; }
        if (orderData.zip === '') { alert('Prosím vyplňte PSČ.'); return; }
        if (orderData.country === '') { alert('Prosím vyplňte zemi.'); return; }
        if (orderData.email === '') { alert('Prosím vyplňte e-mail.'); return; }
        if (orderData.terms !== true) { alert('Před odesláním objednávky je nutno odsouhlasit obchodní podmínky'); return; }

        const fd = new FormData();
        for (const i in orderData) fd.append(i, orderData[i]);
        api('account/purchase-cookbook', { post: true, data: fd }).then(() => setOrderSent(true));
    };

    if (orderSent) {
        return (
            <div className="p-[1em]" style={{ textAlign: 'center' }}>
                <p style={{ fontSize: '5em', margin: '0 0 .15em 0', color: '#4eb32d' }}><i className="fa fa-check"></i></p>
                <p><b>Děkujeme! Vaše objednávka byla úspěšně odeslána.</b></p>
                <p>Zaslali jsme na Váš e-mail potvrzení objednávky společně s platebními údaji pro její úhradu.</p>
            </div>
        );
    }

    const companyData = inputCompanyData ? (
        <>
            <h3>Firemní údaje</h3>
            <p><span>Název firmy:</span><br /><input onChange={onChange} type="text" name="company_name" value={orderData.company_name} /></p>
            <div className="flex gap-[1em]">
                <p><span>IČ:</span><br /><input type="text" onChange={onChange} name="ic" value={orderData.ic} /></p>
                <p><span>DIČ:</span><br /><input type="text" onChange={onChange} name="dic" value={orderData.dic} /></p>
            </div>
        </>
    ) : (
        <p><input type="checkbox" onChange={() => setInputCompanyData(true)} /> fakturujete na firmu?</p>
    );

    const commentData = inputComment ? (
        <>
            <h3>Poznámka</h3>
            <p><textarea onChange={onChange} name="comment" value={orderData.comment} /></p>
        </>
    ) : (
        <p><input type="checkbox" onChange={() => setInputComment(true)} /> připojit poznámku</p>
    );

    const priceInfo = orderData.currency === 'EUR' ? '40 EUR' : '990 Kč';
    const currencySwitch = <a className="whitespace-nowrap font-normal text-base bg-[#26AA52] cursor-pointer text-white px-3 py-2 no-underline rounded text-center hover:bg-[#2bbf5c] hover:text-white" style={{fontSize:'12px',padding:'4px 5px'}} onClick={switchCurrency}>{orderData.currency === 'EUR' ? 'Chci zaplatit v CZK' : 'Chci zaplatit v EUR'}</a>;

    return (
        <div className="p-[1em]" style={{padding:'1em'}}>
            <div style={{height:'80vh',maxHeight:'700px'}}>
                <Scrollbars heightrelativetoparent="1">
                    <div style={{ flex: '1', overflow: 'hidden', padding: '0 14px 0 0' }}>
                        <div className="mb-[1em] [&>div]:flex [&>div]:items-start [&>div]:mb-[0.5em] [&>div>i]:mt-[0.3em] [&>div>i]:mr-[0.5em] [&>div>i]:text-[#26AA52] [&>div>p]:m-0">
                            <div><i className="fa fa-check"></i> <p>Získejte neomezený přístup k ZOF kuchařce, která aktuálně obsahuje více než 700 receptů (další neustále přibývají).</p></div>
                            <div><i className="fa fa-check"></i> <p>Vybírejte a používejte tyto recepty ve svých jídelníčcích a upravujte je dle svých potřeb a představ.</p></div>
                            <div><i className="fa fa-check"></i> <p>Využívejte potenciál generátoru jídelníčků - vytvoří stravovací plán, který nutričně vyhovuje vašemu profilu.</p></div>
                        </div>
                        <p style={{margin:'2em 0'}}>Jednorázová cena přístupu k ZOF kuchařce je <b>{priceInfo}</b>. {currencySwitch}</p>
                        <form>
                            <p><span>Vaše jméno *:</span><br /><input onChange={onChange} type="text" name="name" value={orderData.name} /></p>
                            <div className="flex gap-[1em]">
                                <p><span>Ulice *:</span><br /><input onChange={onChange} type="text" name="street" value={orderData.street} /></p>
                                <p><span>Město *:</span><br /><input onChange={onChange} type="text" name="city" value={orderData.city} /></p>
                            </div>
                            <div className="flex gap-[1em]">
                                <p><span>PSČ *:</span><br /><input onChange={onChange} type="text" name="zip" value={orderData.zip} /></p>
                                <p><span>Země *:</span><br /><input onChange={onChange} type="text" name="country" value={orderData.country} /></p>
                            </div>
                            <div className="flex gap-[1em]">
                                <p><span>E-mail *:</span><br /><input onChange={onChange} type="text" name="email" value={orderData.email} /></p>
                                <p><span>Telefon:</span><br /><input onChange={onChange} type="text" name="phone" value={orderData.phone} /></p>
                            </div>
                            {companyData}
                            {commentData}
                            <p className="text-[0.85em] text-[#666]">Forma úhrady je bankovní převod (platbu kartou připravujeme). Údaje k platbě Vám budou zaslány na e-mail obratem po odeslání objednávky. Plnohodnotný přístup Vám bude aktivován do 2 pracovních dnů po obdržení platby.</p>
                            <p><input type="checkbox" name="terms" onChange={onChange} /> souhlasím s <a target="_blank" href="https://www.zofapp.cz/obchodni-podminky">obchodními podmínkami</a></p>
                            <p><button onClick={sendOrder}>Odeslat objednávku</button></p>
                        </form>
                    </div>
                </Scrollbars>
            </div>
        </div>
    );
}

export default PanelPurchaseCookbook;
